/* =====================================================================
   FRACAZ · Lluvia para «Rain. Splash. Everyday.»
   Tres capas de profundidad:
   - Lejos: gotas finas y lentas en un lienzo DETRÁS de la foto (la foto
     las tapa, como haría en la realidad).
   - Media y cerca: gotas más largas y rápidas DELANTE de la foto. Solo
     chocan con la MOCHILA y con la línea gris del suelo; sobre la persona
     o el chubasquero siguen cayendo. La mochila es un contorno trazado
     sobre la foto (ajuste «Contorno de la mochila»), en % de la FOTO
     ENTERA: vale igual si la foto tiene fondo negro o transparente.
   Al chocar: corona pequeña, gotitas que salen despedidas según la
   inclinación del borde (arriba saltan hacia arriba, en los lados resbalan
   hacia fuera) y, de vez en cuando, una gota que se escurre por la base de
   la mochila y cae.
   Todas las gotas de un mismo tono se pintan de una vez, así que cuesta
   poco aunque haya muchas. Solo se anima con la sección en pantalla y solo
   se pinta la franja que se ve (en móvil, a resolución normal). En cada
   fotograma no se mide nada de la página (no frena el scroll de la escena
   siguiente): el contorno se mide al cargar, al cambiar de tamaño y cuando
   termina de aparecer la foto.
   Respeta «reducir movimiento» (sin lluvia).
   ===================================================================== */
(function () {
  'use strict';
  if (window.__fzRain) return;
  window.__fzRain = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var BASE_WIND = 0.17;
  var BUCKETS = 4; // tonos según lo oscuro del cielo
  var LAYERS = [
    { share: 0.48, len: [6, 11], v: [520, 700], a: 0.16, w: 0.8, back: true },
    { share: 0.37, len: [13, 22], v: [800, 1020], a: 0.3, w: 1 },
    { share: 0.15, len: [26, 42], v: [1140, 1440], a: 0.46, w: 1.4 }
  ];

  function rnd(r) { return r[0] + Math.random() * (r[1] - r[0]); }
  function lerp(a, b, k) { return Math.round(a + (b - a) * k); }
  // sobre el cielo claro la gota es gris oscura; sobre la noche, casi blanca
  function tone(k) { return lerp(70, 226, k) + ',' + lerp(74, 232, k) + ',' + lerp(80, 238, k); }

  // «x,y x,y …» en % de la foto → [[0..1, 0..1], …]
  function parseShape(str) {
    var pts = [];
    (str || '').replace(/(-?\d+(?:\.\d+)?)\s*,\s*(-?\d+(?:\.\d+)?)/g, function (m, x, y) {
      pts.push([parseFloat(x) / 100, parseFloat(y) / 100]);
      return m;
    });
    return pts.length >= 3 ? pts : null;
  }

  function Rain(sec) {
    var cv = sec.querySelector('[data-fz-rain]');
    if (!cv || cv.__fzRain) return;
    cv.__fzRain = true;
    var cvB = sec.querySelector('[data-fz-rain-back]');
    var ctx = cv.getContext('2d');
    var ctxB = cvB ? cvB.getContext('2d') : null;
    var sky = sec.querySelector('.fz-water__sky');
    var photo = sec.querySelector('[data-fz-rain-bag]');
    var reveal = photo ? photo.closest('[data-fz-reveal]') : null;
    var shape = photo ? parseShape(photo.getAttribute('data-fz-rain-bag')) : null;
    var dpr = window.innerWidth < 750 ? 1 : Math.min(1.5, window.devicePixelRatio || 1);
    var secTop = 0; // posición de la sección en la página (para saber qué franja se ve)
    var amount = parseFloat(sec.getAttribute('data-rain-amount')) || 1;
    var W = 0, H = 0, fade = 0, gx = 0;
    var drops = [], rings = [], bits = [], drips = [], flashes = [];
    var poly = null, bb = null, base = [], dripClock = 0, revealSeen = false;
    var running = false, visible = false, last = 0, raf = 0, clock = 0, wind = BASE_WIND;
    var lastBand = [0, 0];

    /* ---------- Contorno de la mochila en píxeles de la sección ---------- */
    function measure() {
      poly = null;
      bb = null;
      base = [];
      var s0 = sec.getBoundingClientRect();
      secTop = s0.top + window.scrollY;
      if (!shape || !photo) return;
      var s = s0;
      var r = photo.getBoundingClientRect();
      if (!r.width || !r.height) return;
      var l = r.left - s.left, t = r.top - s.top;
      poly = shape.map(function (p) { return [l + p[0] * r.width, t + p[1] * r.height]; });
      var x0 = Infinity, y0 = Infinity, x1 = -Infinity, y1 = -Infinity;
      poly.forEach(function (p) {
        if (p[0] < x0) x0 = p[0];
        if (p[0] > x1) x1 = p[0];
        if (p[1] < y0) y0 = p[1];
        if (p[1] > y1) y1 = p[1];
      });
      bb = { x0: x0, y0: y0, x1: x1, y1: y1 };
      // Tramos de la base (el 18 % más bajo) desde donde se escurre el agua
      var cut = y1 - (y1 - y0) * 0.18;
      for (var i = 0; i < poly.length; i++) {
        var a = poly[i], b = poly[(i + 1) % poly.length];
        if (a[1] >= cut && b[1] >= cut) base.push([a, b]);
      }
    }

    function shown() {
      return !reveal || reveal.classList.contains('is-in') || !document.documentElement.classList.contains('fz-motion');
    }

    function inside(x, y) {
      if (!poly || x < bb.x0 || x > bb.x1 || y < bb.y0 || y > bb.y1) return false;
      var c = false;
      for (var i = 0, j = poly.length - 1; i < poly.length; j = i++) {
        var a = poly[i], b = poly[j];
        if ((a[1] > y) !== (b[1] > y) && x < (b[0] - a[0]) * (y - a[1]) / (b[1] - a[1]) + a[0]) c = !c;
      }
      return c;
    }

    // Primer punto donde el tramo p→q cruza el contorno, con la normal hacia fuera de ese borde
    function hit(px, py, qx, qy) {
      var best = null, bt = 2;
      var rx = qx - px, ry = qy - py;
      for (var i = 0; i < poly.length; i++) {
        var a = poly[i], b = poly[(i + 1) % poly.length];
        var sx = b[0] - a[0], sy = b[1] - a[1];
        var den = rx * sy - ry * sx;
        if (!den) continue;
        var t = ((a[0] - px) * sy - (a[1] - py) * sx) / den;
        var u = ((a[0] - px) * ry - (a[1] - py) * rx) / den;
        if (t >= 0 && t <= 1 && u >= 0 && u <= 1 && t < bt) {
          bt = t;
          var len = Math.sqrt(sx * sx + sy * sy) || 1;
          var nx = sy / len, ny = -sx / len;
          // que la normal apunte hacia donde venía la gota
          if (nx * -rx + ny * -ry < 0) { nx = -nx; ny = -ny; }
          best = { x: px + rx * t, y: py + ry * t, nx: nx, ny: ny };
        }
      }
      return best;
    }

    /* ---------- Gotas ---------- */
    function place(d, initial) {
      var lay = LAYERS[d.L];
      d.x = -H * 0.24 + Math.random() * (W + H * 0.24);
      d.y = initial ? Math.random() * H : -24 - Math.random() * H * 0.22;
      d.len = rnd(lay.len);
      d.v = rnd(lay.v);
      // el suelo es la línea gris que hay justo debajo de la sección
      d.end = H - 1 - Math.random() * 2;
      d.b = 0;
      return d;
    }

    // Ninguna gota delantera arranca dentro de la mochila
    function clearInside() {
      if (!poly) return;
      for (var i = 0; i < drops.length; i++) {
        var d = drops[i];
        if (d.L > 0 && inside(d.x, d.y)) d.y = bb.y0 - 4 - Math.random() * Math.max(0, bb.y0 - 4);
      }
    }

    function size() {
      var r = sec.getBoundingClientRect();
      W = r.width;
      H = r.height;
      if (!W || !H) return;
      [cv, cvB].forEach(function (c) {
        if (!c) return;
        c.width = Math.round(W * dpr);
        c.height = Math.round(H * dpr);
        c.style.width = W + 'px';
        c.style.height = H + 'px';
        c.getContext('2d').setTransform(dpr, 0, 0, dpr, 0, 0);
      });
      lastBand = [0, H];
      fade = sky ? sky.offsetHeight : 0;
      // la línea va de margen a margen: fuera de ella las gotas no salpican
      gx = parseFloat(window.getComputedStyle(sec).paddingLeft) || 0;
      var n = Math.round(Math.min(900, (W * H) / 2100) * amount);
      drops = [];
      for (var i = 0; i < n; i++) {
        var u = Math.random();
        var L = u < LAYERS[0].share ? 0 : u < LAYERS[0].share + LAYERS[1].share ? 1 : 2;
        if (L === 0 && !ctxB) L = 1;
        drops.push(place({ L: L }, true));
      }
      rings = [];
      bits = [];
      drips = [];
      flashes = [];
      measure();
      clearInside();
    }

    // 0 = cielo claro (arriba), 1 = noche
    function darkAt(y) {
      if (!fade) return 1;
      var k = (y - fade * 0.15) / (fade * 0.85);
      return k < 0 ? 0 : k > 1 ? 1 : k;
    }

    // nx, ny: normal del borde donde choca (suelo: 0, -1)
    // bag: el choque es contra la mochila (se nota más que en el suelo)
    function splash(x, y, d, nx, ny, bag) {
      var big = d.L === 2;
      var flat = ny < -0.75; // superficie casi horizontal: corona
      if (flat && rings.length < 160 && Math.random() < (d.L === 0 ? 0.3 : 0.9)) {
        rings.push({ x: x, y: y, r: bag ? 1.2 : 0.6, a: d.L === 0 ? 0.35 : (bag || big) ? 0.95 : 0.6, g: bag ? (big ? 1.9 : 1.5) : (big ? 1.3 : 1) });
      }
      if (bag && flashes.length < 60) flashes.push({ x: x, y: y, t: 0.07, r: big ? 2.6 : 2 });
      if (d.L === 0 || bits.length > 420) return;
      var n = bag ? (big ? 4 : 3) : (big ? 3 : 2);
      for (var k = 0; k < n; k++) {
        var sp = (bag ? 75 : 55) + Math.random() * (bag ? 110 : 95);
        var side = (Math.random() - 0.5) * 1.3;
        // sale despedida a lo largo de la normal, abierta un poco a los lados
        var vx = (nx - ny * side) * sp + wind * 60;
        var vy = (ny + nx * side) * sp - (flat ? 25 : 0);
        bits.push({
          x: x + nx,
          y: y + ny,
          vx: vx * (big ? 1.25 : 1),
          vy: vy * (big ? 1.25 : 1),
          life: (bag ? 0.3 : 0.24) + Math.random() * 0.22,
          a: bag ? 0.95 : big ? 0.8 : 0.55,
          s: bag ? (big ? 2.4 : 1.9) : 1.3
        });
      }
    }

    function frame(t) {
      raf = 0;
      if (!running) return;
      var dt = last ? Math.min(0.05, (t - last) / 1000) : 0.016;
      last = t;
      clock += dt;
      // ráfagas suaves de viento
      wind = BASE_WIND + 0.05 * Math.sin(clock * 0.33) + 0.02 * Math.sin(clock * 1.27 + 1.3);
      // La foto termina de aparecer (escala 1,16 → 1 en 2 s): se vuelve a medir al acabar
      if (!revealSeen && reveal && reveal.classList.contains('is-in')) {
        revealSeen = true;
        setTimeout(function () { measure(); clearInside(); }, 2100);
      }
      var solid = poly && shown();
      // Franja visible de la sección (con margen para las gotas largas), sin medir la página
      var vy0 = window.scrollY - secTop - 60, vy1 = vy0 + window.innerHeight + 120;
      if (vy0 < 0) vy0 = 0;
      if (vy1 > H) vy1 = H;

      for (var i = 0; i < drops.length; i++) {
        var d = drops[i];
        var px = d.x, py = d.y;
        d.y += d.v * dt;
        d.x += d.v * wind * dt;
        if (d.L > 0 && solid && !(d.y < bb.y0 || py > bb.y1 || Math.max(px, d.x) < bb.x0 || Math.min(px, d.x) > bb.x1)) {
          var h = hit(px, py, d.x, d.y);
          if (h) {
            splash(h.x, h.y, d, h.nx, h.ny, true);
            place(d, false);
            continue;
          }
        }
        if (d.y >= d.end) {
          if (d.x >= gx && d.x <= W - gx) splash(d.x, d.end, d, 0, -1);
          place(d, false);
          continue;
        }
        var b = Math.floor(darkAt(d.y) * BUCKETS);
        d.b = b >= BUCKETS ? BUCKETS - 1 : b;
      }

      // Agua que se escurre por la base de la mochila
      if (solid && base.length) {
        dripClock -= dt;
        if (dripClock <= 0 && drips.length < 6) {
          dripClock = 0.35 + Math.random() * 0.6;
          var seg = base[Math.floor(Math.random() * base.length)];
          var k = Math.random();
          drips.push({ x: seg[0][0] + (seg[1][0] - seg[0][0]) * k, y: seg[0][1] + (seg[1][1] - seg[0][1]) * k + 1, v: 0, hang: 0.25 + Math.random() * 0.35, len: 0 });
        }
      }

      if (vy1 <= vy0) { raf = window.requestAnimationFrame(frame); return; }
      // Se borra lo pintado en el fotograma anterior (su franja) y lo de ahora
      var cy0 = Math.min(vy0, lastBand[0]), cy1 = Math.max(vy1, lastBand[1]);
      ctx.clearRect(0, cy0, W, cy1 - cy0);
      if (ctxB) ctxB.clearRect(0, cy0, W, cy1 - cy0);
      lastBand[0] = vy0;
      lastBand[1] = vy1;
      // Nada se pinta fuera de la franja (así lo que se borra cubre todo lo pintado)
      [ctx, ctxB].forEach(function (g) {
        if (!g) return;
        g.save();
        g.beginPath();
        g.rect(0, vy0, W, vy1 - vy0);
        g.clip();
      });

      // Gotas: un trazo por capa y tono
      for (var L = 0; L < LAYERS.length; L++) {
        var lay = LAYERS[L];
        var g = (lay.back && ctxB) ? ctxB : ctx;
        g.lineCap = 'round';
        g.lineWidth = lay.w;
        for (var bk = 0; bk < BUCKETS; bk++) {
          var any = false;
          g.beginPath();
          for (var j = 0; j < drops.length; j++) {
            var q = drops[j];
            if (q.L !== L || q.b !== bk || q.y < vy0 || q.y - q.len > vy1) continue;
            g.moveTo(q.x, q.y);
            g.lineTo(q.x - q.len * wind, q.y - q.len);
            any = true;
          }
          if (!any) continue;
          var kk = (bk + 0.5) / BUCKETS;
          g.strokeStyle = 'rgba(' + tone(kk) + ',' + (lay.a * (0.5 + 0.5 * kk)).toFixed(3) + ')';
          g.stroke();
        }
      }

      // Gotas que cuelgan de la base, se alargan y caen
      ctx.lineCap = 'round';
      ctx.lineWidth = 1.2;
      ctx.strokeStyle = 'rgba(226,232,238,0.55)';
      ctx.beginPath();
      for (var di = drips.length - 1; di >= 0; di--) {
        var dr = drips[di];
        if (dr.hang > 0) {
          dr.hang -= dt;
          dr.len = Math.min(5, dr.len + dt * 14);
        } else {
          dr.v += 1500 * dt;
          dr.y += dr.v * dt;
          dr.len = Math.min(16, 4 + dr.v * 0.014);
        }
        if (dr.y >= H - 2) {
          splash(dr.x, H - 2, { L: 1 }, 0, -1);
          drips.splice(di, 1);
          continue;
        }
        ctx.moveTo(dr.x, dr.y);
        ctx.lineTo(dr.x, dr.y + dr.len);
      }
      ctx.stroke();

      // Coronas de las salpicaduras
      ctx.lineWidth = 1;
      for (var m = rings.length - 1; m >= 0; m--) {
        var s = rings[m];
        s.r += dt * 28 * s.g;
        s.a -= dt * 1.6;
        if (s.a <= 0) { rings.splice(m, 1); continue; }
        ctx.strokeStyle = 'rgba(226,232,238,' + (s.a * 0.6).toFixed(3) + ')';
        ctx.beginPath();
        ctx.ellipse(s.x, s.y, s.r, s.r * 0.32, 0, Math.PI, Math.PI * 2);
        ctx.stroke();
      }

      // Gotitas que saltan
      ctx.fillStyle = 'rgb(232,238,244)';
      for (var n = bits.length - 1; n >= 0; n--) {
        var o = bits[n];
        o.life -= dt;
        if (o.life <= 0) { bits.splice(n, 1); continue; }
        o.vy += 900 * dt;
        o.x += o.vx * dt;
        o.y += o.vy * dt;
        ctx.globalAlpha = Math.min(1, o.life * 3) * o.a;
        ctx.fillRect(o.x - o.s / 2, o.y - o.s / 2, o.s, o.s);
      }
      // Destello en el punto exacto del choque con la mochila
      for (var fi = flashes.length - 1; fi >= 0; fi--) {
        var fl = flashes[fi];
        fl.t -= dt;
        if (fl.t <= 0) { flashes.splice(fi, 1); continue; }
        ctx.globalAlpha = Math.min(1, fl.t / 0.07);
        ctx.beginPath();
        ctx.arc(fl.x, fl.y, fl.r, 0, Math.PI * 2);
        ctx.fill();
      }
      ctx.globalAlpha = 1;
      ctx.restore();
      if (ctxB) ctxB.restore();

      raf = window.requestAnimationFrame(frame);
    }

    // Mientras llueve, la posición de la sección se revisa de vez en cuando fuera de los fotogramas
    var remeasureT = 0;
    function start() {
      if (running || reduce.matches || document.hidden || !visible) return;
      running = true;
      last = 0;
      measure();
      clearInterval(remeasureT);
      remeasureT = setInterval(measure, 2000);
      if (!raf) raf = window.requestAnimationFrame(frame);
    }
    function stop() {
      running = false;
      clearInterval(remeasureT);
      if (raf) { window.cancelAnimationFrame(raf); raf = 0; }
    }

    size();
    if (photo && !photo.complete) photo.addEventListener('load', function () { measure(); clearInside(); }, { once: true });
    new IntersectionObserver(function (entries) {
      visible = entries[0].isIntersecting;
      if (visible) start(); else stop();
    }, { rootMargin: '10% 0px 10% 0px' }).observe(sec);
    document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else start(); });
    if (reduce.addEventListener) {
      reduce.addEventListener('change', function () {
        if (reduce.matches) {
          stop();
          ctx.clearRect(0, 0, W, H);
          if (ctxB) ctxB.clearRect(0, 0, W, H);
        } else start();
      });
    }
    if (window.ResizeObserver) {
      var pending = false;
      new ResizeObserver(function () {
        if (pending) return;
        pending = true;
        window.requestAnimationFrame(function () {
          pending = false;
          var r = sec.getBoundingClientRect();
          if (Math.abs(r.width - W) > 1 || Math.abs(r.height - H) > 1) size();
          else measure();
        });
      }).observe(sec);
    }
  }

  function init(root) {
    Array.prototype.forEach.call((root || document).querySelectorAll('[data-fz-rain-scene]'), Rain);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
